
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, bool_type, option_type, string_type, class_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class ChatMessageDto extends Record {
    constructor(Id, ConversationId, SenderId, SenderUsername, MessageText, ImageUrl, CreatedAt, IsDeleted) {
        super();
        this.Id = Id;
        this.ConversationId = ConversationId;
        this.SenderId = SenderId;
        this.SenderUsername = SenderUsername;
        this.MessageText = MessageText;
        this.ImageUrl = ImageUrl;
        this.CreatedAt = CreatedAt;
        this.IsDeleted = IsDeleted;
    }
}

export function ChatMessageDto_$reflection() {
    return record_type("Shared.Chat.ChatMessageDto", [], ChatMessageDto, () => [["Id", class_type("System.Guid")], ["ConversationId", class_type("System.Guid")], ["SenderId", string_type], ["SenderUsername", string_type], ["MessageText", option_type(string_type)], ["ImageUrl", option_type(string_type)], ["CreatedAt", class_type("System.DateTime")], ["IsDeleted", bool_type]]);
}

export class ChatConversationDto extends Record {
    constructor(Id, Name, IsGroup, ParticipantUserIds, AdminUserIds, CreatedAt, CreatedByUserId, LastMessage) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.IsGroup = IsGroup;
        this.ParticipantUserIds = ParticipantUserIds;
        this.AdminUserIds = AdminUserIds;
        this.CreatedAt = CreatedAt;
        this.CreatedByUserId = CreatedByUserId;
        this.LastMessage = LastMessage;
    }
}

export function ChatConversationDto_$reflection() {
    return record_type("Shared.Chat.ChatConversationDto", [], ChatConversationDto, () => [["Id", class_type("System.Guid")], ["Name", option_type(string_type)], ["IsGroup", bool_type], ["ParticipantUserIds", list_type(string_type)], ["AdminUserIds", list_type(string_type)], ["CreatedAt", class_type("System.DateTime")], ["CreatedByUserId", string_type], ["LastMessage", option_type(ChatMessageDto_$reflection())]]);
}

export class ChatUserDto extends Record {
    constructor(Id, Name, Department) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Department = Department;
    }
}

export function ChatUserDto_$reflection() {
    return record_type("Shared.Chat.ChatUserDto", [], ChatUserDto, () => [["Id", string_type], ["Name", string_type], ["Department", string_type]]);
}

export class CreateChatConversationDto extends Record {
    constructor(Name, ParticipantUserIds) {
        super();
        this.Name = Name;
        this.ParticipantUserIds = ParticipantUserIds;
    }
}

export function CreateChatConversationDto_$reflection() {
    return record_type("Shared.Chat.CreateChatConversationDto", [], CreateChatConversationDto, () => [["Name", option_type(string_type)], ["ParticipantUserIds", list_type(string_type)]]);
}

export class SendChatMessageDto extends Record {
    constructor(MessageText, ImageUrl) {
        super();
        this.MessageText = MessageText;
        this.ImageUrl = ImageUrl;
    }
}

export function SendChatMessageDto_$reflection() {
    return record_type("Shared.Chat.SendChatMessageDto", [], SendChatMessageDto, () => [["MessageText", option_type(string_type)], ["ImageUrl", option_type(string_type)]]);
}

export class UpdateGroupNameDto extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function UpdateGroupNameDto_$reflection() {
    return record_type("Shared.Chat.UpdateGroupNameDto", [], UpdateGroupNameDto, () => [["Name", string_type]]);
}

export class AddGroupMembersDto extends Record {
    constructor(UserIds) {
        super();
        this.UserIds = UserIds;
    }
}

export function AddGroupMembersDto_$reflection() {
    return record_type("Shared.Chat.AddGroupMembersDto", [], AddGroupMembersDto, () => [["UserIds", list_type(string_type)]]);
}

export class SetGroupAdminDto extends Record {
    constructor(IsAdmin) {
        super();
        this.IsAdmin = IsAdmin;
    }
}

export function SetGroupAdminDto_$reflection() {
    return record_type("Shared.Chat.SetGroupAdminDto", [], SetGroupAdminDto, () => [["IsAdmin", bool_type]]);
}

